import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-config-review-work-flow-layout',
    templateUrl: './config-review-work-flow-layout.component.html',
    styleUrls: ['./config-review-work-flow-layout.component.css'],
    standalone: false
})
export class ConfigReviewWorkFlowLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
